const getState = (state) => state.app.firebase;

export const getAllNotifications = (state) => getState(state).notifications || [];

export const getActiveNotifications = (state) => getAllNotifications(state).filter((row) => !row.closed) || [];

export const getNewNotifications = (state) => getAllNotifications(state).filter((row) => !row.entered) || [];
